export default {
    data() {
        return {
            translations: {
                highlightedText: window.Drupal.t('Most chosen'),
                rentVehicleText: window.Drupal.t('Rent this vehicle'),
                searchText: window.Drupal.t('Search'),
                searchPlaceholder: window.Drupal.t('What are you looking for?'),
                loadingText: window.Drupal.t('Loading..'),
                noResultsText: window.Drupal.t('No results!'),
                vehicleFiltersTitle: window.Drupal.t('Filters and options'),
                titleAscText: window.Drupal.t('Title (Ascending)'),
                titleDescText: window.Drupal.t('Title (Descending)'),
                priceAscText: window.Drupal.t('Price (Ascending)'),
                priceDescText: window.Drupal.t('Price (Descending)'),
                sortText: window.Drupal.t('Sort'),
                clearText: window.Drupal.t('Clear'),
                showText: window.Drupal.t('Show'),
                filterText: window.Drupal.t('Filter'),
                closeText: window.Drupal.t('Close'),
                openText: window.Drupal.t('Open'),
                removeText: window.Drupal.t('Remove'),
                amountText: window.Drupal.t('Amount'),
                totalText: window.Drupal.t('Total'),
                datesErrorText: window.Drupal.t('The return date must be later than the departure date!'),
                datesMinimalWeek: window.Drupal.t('The vehicle must be rented for at least a week!'),
                locationDropdownTitle: window.Drupal.t("Where do you want to rent?"),
                locationDropdownLabel: window.Drupal.t('Search on postal code or place '),
                locationDropdownInfo: window.Drupal.t('You can only search for a location that has the selected vehicle in its range.'),
                rentalPeriodTitle: window.Drupal.t('Select a rental period'),
                freeKilometersTitle: window.Drupal.t('Select an amount of free kilometers'),
                rentalPeriodText: window.Drupal.t('Rental period'),
                rentalPrice: window.Drupal.t('Rental price'),
                rentalPriceConsumer: window.Drupal.t('Rental price incl. BTW'),
                rentalPriceBusiness: window.Drupal.t('Rental price excl. BTW'),
                rentalPeriodInfo: window.Drupal.t('A rental day is from 08:00 to 08:00 the next day.'),
                departureLabel: window.Drupal.t('Departure date'),
                datetimePickerLabel: window.Drupal.t('Select your rental daterange'),
                pickupLabel: window.Drupal.t('Tijdstip ophalen'),
                returnLabel: window.Drupal.t('Due date'),
                extraDayWarning: window.Drupal.t('<strong>Pay attention!</strong> You have now selected a time <strong>after 8:00 AM.</strong> This means that an <strong>extra day</strong> is added.'),
                reservationInfo: window.Drupal.t('Book earlier? <a href="tel:+31612345678">Give us a call!</a>'),
                backText: window.Drupal.t('Back'),
                backOptionsText: window.Drupal.t('Back to options'),
                backRentalPeriodText: window.Drupal.t('Change rentalperiod'),
                nextText: window.Drupal.t('Next'),
                nextDataText: window.Drupal.t('Proceed to data'),
                nextOptionsText: window.Drupal.t('Proceed to options'),
                locationLabel: window.Drupal.t('Location'),
                locationSearchPlaceholder: window.Drupal.t('Place or zipcode'),
                moreInformation: window.Drupal.t('More information'),
                freeKilometers: window.Drupal.t('Free km'),
                upgradeLabel: window.Drupal.t('Or upgrade your vehicle to:'),
                downgradeLabel: window.Drupal.t('Or downgrade your vehicle to:'),
                upgradeButton: window.Drupal.t('Upgrade your vehicle'),
                downgradeButton: window.Drupal.t('Downgrade your vehicle'),
                extraOptionsTitle: window.Drupal.t('Extra options'),
                afterFourWarning: window.Drupal.t('<strong>Pay attention</strong> you can\'t pick up the vehicle because it is after 4 o\'clock please call:'),
                errorTryAgainText: window.Drupal.t('Something went wrong, please try again later.'),
                doorsText: window.Drupal.t('doors'),
                personsText: window.Drupal.t('persons'),
                suitcasesText: window.Drupal.t('suitcases'),
                addToCalendar: window.Drupal.t('Add to my calendar'),
                overviewOfYourOrder: window.Drupal.t('Overview of your order'),
                selectAnyAdditionalOptions: window.Drupal.t('Select any additional options'),
                weOnlyNeedAdditionalInformation: window.Drupal.t('We only need some additional information'),
                extraOptions: window.Drupal.t('Extra options'),
                emailValidation: window.Drupal.t('Please enter a valid email'),
                zipCodeValidation: window.Drupal.t('Please enter a valid zip code'),
                onlyYourDataLeft: window.Drupal.t('Only your data left'),
                maleTitle: window.Drupal.t('Mr'),
                femaleTitle: window.Drupal.t('Mrs'),
                otherTitle: window.Drupal.t('Other'),
                companyName: window.Drupal.t('Company name'),
                firstName: window.Drupal.t('First name'),
                lastName: window.Drupal.t('Last name'),
                addressData: window.Drupal.t('Address data'),
                postalCode: window.Drupal.t('Postal code'),
                houseNumber: window.Drupal.t('House number'),
                streetName: window.Drupal.t('Street name'),
                placeName: window.Drupal.t('Place name'),
                country: window.Drupal.t('Country'),
                contactDetails: window.Drupal.t('Contact details'),
                emailAddress: window.Drupal.t('Email address'),
                phoneNumber: window.Drupal.t('Phone number'),
                registerForNewsletter: window.Drupal.t('I subscribe to your newsletter.'),
                acceptTermsAndConditions: window.Drupal.t('I have read and agree to the terms and conditions and the privacy statement.'),
                sendRequest: window.Drupal.t('Send request'),
                sendRequestMobile: window.Drupal.t('Send'),
                nonBindingText: window.Drupal.t('100% non-binding.'),
                freeCancellation: window.Drupal.t('Free cancellation up to 24 hours in advance.'),
                geoInputPlaceholder: window.Drupal.t('Search by city or postal code'),
                geoInputPlaceholderLoading: window.Drupal.t('Loading... '),
                geoInputPlaceholderCurrentLocation: window.Drupal.t('Using current location '),
                openToday: window.Drupal.t('Open today from'),
                open: window.Drupal.t('Open'),
                openAt: window.Drupal.t('Gaat open om'),
                closed: window.Drupal.t('Closed'),
                until: window.Drupal.t('until'),
                nearestLocation: window.Drupal.t('Find your nearest location'),
                dealerNearby: window.Drupal.t('Find a dealer nearby'),
                selectedFilters: window.Drupal.t('Selected filters'),
                goToLocation: window.Drupal.t('Go to location'),
                allLocationsInOneRow: window.Drupal.t('All locations in a row'),
                showOnMap: window.Drupal.t('Show on map'),
                bookEarlier: window.Drupal.t('Book earlier?'),
                giveUsACall: window.Drupal.t('Give us a call!'),
                rentDirectly: window.Drupal.t('Rent directly'),
                getCurrentLocationText: window.Drupal.t('Get my current location.'),
                salutation: window.Drupal.t('Salutation'),
                day: window.Drupal.t('Day'),
                weekend: window.Drupal.t('Weekend'),
                week: window.Drupal.t('1 week'),
                driversLicenseLabel: window.Drupal.t('Drivers license'),
                cargoSpaceLabel: window.Drupal.t('Cargo space'),
                pickupPointSelectorLabel: window.Drupal.t('Pick-up point'),
                pickupPointSelectorPlaceholder: window.Drupal.t('Please select a pick-up point'),
                amountOfPersonsSuffix: window.Drupal.t('persons'),
                suitcasesSuffix: window.Drupal.t('suitcases'),
                amountOfDoorsSuffix: window.Drupal.t('doors'),
                discountLink: window.Drupal.t('Korting'),
                closeTextDiscountPopup: window.Drupal.t('Toevoegen'),
                discountLinkEmpty: window.Drupal.t('Kortingscode toevoegen'),
                discountLinkChange: window.Drupal.t('Kortingscode wijzigen'),
                openDiscountText: window.Drupal.t('Korting'),
                checkReceipt: window.Drupal.t('Details'),
                login: window.Drupal.t('Login'),
                continueAsGuest: window.Drupal.t('Verder als nieuwe gebruiker'),
                dataCorrect: window.Drupal.t('Are your details still correct?'),
                createAccount: window.Drupal.t('I want to create an account immediately'),
                password: window.Drupal.t('Password'),
                confirmPassword: window.Drupal.t('Confirm password'),
                loginSubmit: window.Drupal.t('Inloggen'),
                loginError: window.Drupal.t('Ongeldige inloggegevens. Probeer het opnieuw.'),
            }
        }
    }
}
